<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-body">
        <calender-checklist></calender-checklist>
      </div>
    </div>
  </div>
</template>

<script>
import CalenderChecklist from './calender-checklist'
export default {
  components: {
    CalenderChecklist
  },
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
  },
  name: 'dashboard'
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue